module.exports = __webpack_public_path__ + "static/orangecreamsoda-d13a5e8b3a450be4d2ff71edcfea9c27.jpg";